import { fetchApi } from '@/config/axiosSetting.ts';
import { InsurerInformationQuery } from '@/modules/FileDetail/queries/insurerInformation/insurerInformationQuery.type.ts';

export const insurerInformationQueryFunction = (
  id: string,
): Promise<InsurerInformationQuery> =>
  fetchApi.get(`/file_information/${id}/insurer_information/`);
